import React from 'react';

/**
 * Universal Section Header Component
 * Provides uniform typography, badges, and margins across all landing and sub-pages.
 */
export default function SectionHeader({ tag, title, subtitle, align = 'center', className = '' }) {
  const isCenter = align === 'center';

  return (
    <div className={`mb-10 sm:mb-12 ${isCenter ? 'text-center max-w-3xl mx-auto' : 'max-w-2xl'} ${className}`}>
      {tag && (
        <div className="inline-block px-3 py-1 rounded-full bg-[#e6faf8] text-[#00796b] text-[11px] font-extrabold uppercase tracking-wider mb-2">
          {tag}
        </div>
      )}
      {title && (
        <h2 className="text-2xl sm:text-3xl font-extrabold text-[#0f172a] tracking-tight">
          {title}
        </h2>
      )}
      {subtitle && (
        <p className="text-xs sm:text-sm text-gray-500 mt-2.5 leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  );
}
